var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.shown ? 'loading-container pt-4 show' : 'loading-container pt-4'},[_c('div',[_c('div',{staticClass:"icon-ct"},[_c('loading')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }